import { Switch as AntSwitch, SwitchProps } from 'antd';
import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { FormInput, FormInputProps } from '../FormInput/FormInput';

import './Switch.scss';

export interface SwitchOwnProps extends SwitchProps, Omit<FormInputProps, 'label'> {
  containerClassName?: string;
  labelClassName?: string;
  className?: string;
  label?: ReactNode;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchOwnProps>(
  (
    {
      className,
      containerClassName,
      labelClassName,
      disabled = false,
      label = null,
      onChange,
      errorMessage,
      ...restProps
    },
    ref,
  ) => {
    return (
      <FormInput errorMessage={errorMessage}>
        <label data-testid="switch-container" className={classNames('custom-switch', containerClassName)}>
          <AntSwitch
            ref={ref}
            {...restProps}
            className={classNames('custom-switch__element', className)}
            disabled={disabled}
            onChange={onChange}
            data-testid="switch-element"
          />
          {label && (
            <span data-testid="switch-label" className={classNames('custom-switch__label', labelClassName)}>
              {label}
            </span>
          )}
        </label>
      </FormInput>
    );
  },
);
